//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import tributaryUrlTagsWarningTemplate from '@legacy-components/common/universal-image-actions/tributary-url-tags-warning.html';

(function() {
  const uia = angular.module('uia');
  uia.component('tributaryUrlTagsWarning', {
    template: tributaryUrlTagsWarningTemplate,
    controller: [
      'ShowroomService',
      'TrackingService',
      'UniversalImageActionsHelpers',
      'UniversalImageActionsService',
      function(ShowroomService, TrackingService, UniversalImageActionsHelpers, UniversalImageActionsService) {
        const self = this;
        const TRACKING_CATEGORY = UniversalImageActionsHelpers.getTrackingCategory(UniversalImageActionsService.getCurrentPage());

        self.helpLinkClicked = function() {
          TrackingService.recordEvent(TRACKING_CATEGORY, ShowroomService.getTrackingAction(), 'HelpLinkClicked', 'AllCrawled');
        };
      },
    ],
  });
})();
